import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import { authApi } from '../features/auth/authApi';
import { authTokenMiddleware } from './authTokenMiddleware';
import { kycApi } from '../features/kyc/kycApi';
import { kycTemplatesApi } from '../features/kyc/kycTemplatesApi';
import { investorsApi } from '../features/investors/investorsApi';
import { investmentsApi } from '../features/investments/investmentsApi';
import { auditApi } from '../features/audit/auditApi';
import { adminAccountsApi } from '../features/admin/adminAccountsApi';
import { plansApi } from '../features/plans/plansApi';
import { investmentPlansApi } from '../features/investmentPlans/investmentPlansApi';
import { onboardInvestorApi } from '../features/investors/onboardInvestorApi';
import { adminInvestorsApi } from '../features/investors/adminInvestorsApi';
import { adminInvestmentsApi } from '../features/investments/adminInvestmentsApi';
import { investorInvestmentsApi } from '../features/investments/investorInvestmentsApi';
import { paymentsApi } from '../features/payments/paymentsApi';
import { payoutsApi } from '../features/payouts/payoutsApi';
import { notificationsApi } from '../features/notifications/notificationsApi';
import { ticketsApi } from '../features/tickets/ticketsApi';
import { dashboardApi } from '../features/dashboard/dashboardApi';
import { reportsApi } from '../features/reports/reportsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [kycApi.reducerPath]: kycApi.reducer,
    [kycTemplatesApi.reducerPath]: kycTemplatesApi.reducer,
    [investorsApi.reducerPath]: investorsApi.reducer,
    [investmentsApi.reducerPath]: investmentsApi.reducer,
    [auditApi.reducerPath]: auditApi.reducer,
    [adminAccountsApi.reducerPath]: adminAccountsApi.reducer,
    [plansApi.reducerPath]: plansApi.reducer,
    [investmentPlansApi.reducerPath]: investmentPlansApi.reducer,
    [onboardInvestorApi.reducerPath]: onboardInvestorApi.reducer,
    [adminInvestorsApi.reducerPath]: adminInvestorsApi.reducer,
    [adminInvestmentsApi.reducerPath]: adminInvestmentsApi.reducer,
    [investorInvestmentsApi.reducerPath]: investorInvestmentsApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [payoutsApi.reducerPath]: payoutsApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [ticketsApi.reducerPath]: ticketsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authTokenMiddleware,
      authApi.middleware,
      kycApi.middleware,
      kycTemplatesApi.middleware,
      investorsApi.middleware,
      investmentsApi.middleware,
      auditApi.middleware,
      adminAccountsApi.middleware,
      plansApi.middleware,
      investmentPlansApi.middleware,
      onboardInvestorApi.middleware,
      adminInvestorsApi.middleware,
      adminInvestmentsApi.middleware,
      investorInvestmentsApi.middleware,
      paymentsApi.middleware,
      payoutsApi.middleware,
      notificationsApi.middleware,
      ticketsApi.middleware,
      dashboardApi.middleware,
      reportsApi.middleware
    ),
});

export default store;
